// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"O2-z","subtitle":"P2-z","wrapper":"Q2-z","leftArrow":"R2-z","rightArrow":"S2-z"};